export function usingSafari(): boolean {
    return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
